import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore }   from '@/stores/auth'
import { useTenantStore } from '@/stores/tenant'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomeView.vue')
  },
  {
    path: '/:slug',
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/LoginView.vue'),
        meta: { requiresAuth: false }
      },
      {
        path: '',
        name: 'Calendar',
        component: () => import('@/views/CalendarView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'my-bookings',
        name: 'MyBookings',
        component: () => import('@/views/MyBookingsView.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin',
        name: 'Admin',
        component: () => import('@/views/AdminView.vue'),
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  },
  // Catch-all 404
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  const slug   = to.params.slug
  const auth   = useAuthStore()
  const tenant = useTenantStore()

  // No slug means Home page — nothing to guard
  if (!slug) return true

  // Load tenant config if not yet loaded or slug changed
  if (!tenant.loaded || tenant.slug !== slug) {
    await tenant.loadTenant(slug)
  }

  // Invalid slug → 404 (preserve the original URL)
  if (tenant.error) return { name: 'NotFound', params: { pathMatch: to.path.split('/').slice(1) }, replace: true }

  // Wait for session restore (pass slug so token is wired to apiService)
  if (!auth.sessionRestored) {
    await auth.restoreSession(slug)
  }

  if (to.name === 'Login' && auth.isAuthenticated) {
    return { name: 'Calendar', params: { slug } }
  }

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    return { name: 'Login', params: { slug } }
  }

  if (to.meta.requiresAdmin && auth.currentUser?.Role !== 'Admin') {
    return { name: 'Calendar', params: { slug } }
  }
})

export default router
